require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./button"), require("./flyout"), require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./button", "./flyout", "./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./button"), require("./flyout"), require("./utils")) : factory(root["./button"], root["./flyout"], root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__32477__, __WEBPACK_EXTERNAL_MODULE__7662__, __WEBPACK_EXTERNAL_MODULE__78815__) => {
return (globalThis["wpBaUiCarbonToolkit"] = globalThis["wpBaUiCarbonToolkit"] || []).push([[8680],{

/***/ 89017:
/***/ ((module) => {

var amdi18n={"__root":{"title":"Selecting a color"},"__cs":{"title":"Výběr barvy"},"__da":{"title":"Vælg en farve"},"__de":{"title":"Farbe auswählen"},"__es":{"title":"Seleccionando un color"},"__fi":{"title":"Värin valinta"},"__fr":{"title":"Sélection d'une couleur"},"__hr":{"title":"Biranje boje"},"__hu":{"title":"Szín kiválasztása"},"__it":{"title":"Selezione di un colore"},"__ja":{"title":"カラーの選択"},"__kk":{"title":"Түсті таңдау"},"__ko":{"title":"색상 선택"},"__nb":{"title":"Velge en farge"},"__nl":{"title":"Een kleur selecteren"},"__no":{"title":"Velge en farge"},"__pl":{"title":"Wybieranie koloru"},"__pt":{"title":"Selecionando uma Cor"},"__pt-br":{"title":"Selecionando uma Cor"},"__ro":{"title":"Selectarea unei culori"},"__ru":{"title":"Выбор цвета"},"__sl":{"title":"Izbiranje barve"},"__sv":{"title":"Välj en färg"},"__th":{"title":"การเลือกสี"},"__tr":{"title":"Renk seçme"},"__uk":{"title":"Вибір кольору"},"__zh":{"title":"选择颜色"},"__zh-cn":{"title":"选择颜色"},"__zh-hk":{"title":"選取顏色"},"__zh-mo":{"title":"選取顏色"},"__zh-sg":{"title":"选择颜色"},"__zh-tw":{"title":"選取顏色"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 21413:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _textColor_ = _interopRequireDefault(__webpack_require__(71933));
var _utils = __webpack_require__(78815);
var _flyout = __webpack_require__(7662);
var _button = _interopRequireDefault(__webpack_require__(32477));
var _ColorPicker = _interopRequireDefault(__webpack_require__(4457));
var _StringResource = _interopRequireDefault(__webpack_require__(26935));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-carbon-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const DEFAULT_OFFSET = 2;
const colorpickerClassName = _ColorPicker.default.colorpickerClassName.replace(/"/g, '');
const {
  sanitize
} = _utils.propsUtils;
const {
  uniqueId
} = _utils.lodash;
const {
  BOTTOM_RIGHT_START,
  BOTTOM_LEFT_START
} = _flyout.FlyoutPosition;
class ColorPicker extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "_displayColor", (color, index) => /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      tabIndex: "0" // Make it keyboard focusable
      ,
      style: {
        background: color
      },
      className: `${colorpickerClassName}__cell`,
      onClick: () => this._handleSelect(color),
      onKeyDown: e => this._handleKey(e, color)
    }));
    this.state = {
      open: false
    };
    this._handleOpen = this._handleOpen.bind(this);
    this._handleSelect = this._handleSelect.bind(this);
    this._handleKey = this._handleKey.bind(this);
    this._id = uniqueId('ba-common-color-picker__');
    this.buttonRef = _react.default.createRef();
  }
  _handleOpen() {
    this.setState(state => ({
      open: !state.open
    }));
  }
  _handleSelect(color) {
    this.props.onColorSelected(color);
    // close the flyout after selection
    this.setState(state => ({
      open: !state.open
    }));
  }
  _handleKey(e, color) {
    // 13 = Return, 32 = Space
    if (e.keyCode === 13 || e.keyCode === 32) {
      this._handleSelect(color);
      // Prevent browser's default action: space does a PageDown
      e.preventDefault();
    }
  }
  render() {
    const {
      open
    } = this.state;
    const {
      selectedColor,
      disabled,
      title,
      className,
      style,
      buttonExtraOptions,
      flyoutExtraOptions,
      colorbarOffset,
      orientation,
      ...others
    } = this.props;
    const btnClassname = `${colorpickerClassName}__button ${'size' in buttonExtraOptions ? '' : 'size-default'}`;
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, sanitize(others, ColorPicker), {
      className: `${colorpickerClassName} ${className}`,
      ref: node => {
        this._colorPickerNode = node;
      },
      style: style
    }), /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({
      "aria-controls": `${this._id}-flyout`,
      "data-tid": "ba-common-color-picker__button",
      hasIconOnly: true,
      kind: "ghost"
    }, sanitize(buttonExtraOptions, ColorPicker), {
      title: title,
      disabled: disabled,
      icon: _textColor_.default.id,
      ref: this.buttonRef,
      onClick: this._handleOpen,
      className: btnClassname
    }), !disabled && /*#__PURE__*/_react.default.createElement("span", {
      style: {
        background: selectedColor,
        ...colorbarOffset
      },
      className: `${colorpickerClassName}__colorbar`
    })), open && /*#__PURE__*/_react.default.createElement(_flyout.Flyout, (0, _extends2.default)({
      id: `${this._id}-flyout`,
      "data-tid": "ba-common-color-picker__flyout"
    }, flyoutExtraOptions, {
      "aria-hidden": open,
      placement: orientation
      // eslint-disable-next-line no-underscore-dangle
      ,
      triggerNode: this.buttonRef.current._node,
      domNodeToAttachTo: this._colorPickerNode,
      hideArrow: true,
      offset: DEFAULT_OFFSET,
      onClose: this._handleOpen,
      className: `${colorpickerClassName}__flyout`
    }), this.props.colors.map(this._displayColor)));
  }
}
exports["default"] = ColorPicker;
(0, _defineProperty2.default)(ColorPicker, "propTypes", {
  /** Colors to be selected */
  colors: _propTypes.default.array,
  /** Function that will get called on click of a color */
  onColorSelected: _propTypes.default.func,
  /** Selected color to show at the bottom of button */
  selectedColor: _propTypes.default.string,
  /** Flag to disable the color picker */
  disabled: _propTypes.default.bool,
  /** Tooltip when you hover on the color picker */
  title: _propTypes.default.string,
  /** Flyout.propTypes.placement, default bottomRightStart/bottomLeftStart */
  orientation: _flyout.Flyout.propTypes.placement,
  /** Custom class name(s) */
  className: _propTypes.default.string,
  /** Custom css styles */
  style: _propTypes.default.object,
  /** Extra options for the button to pass to Flyout */
  buttonExtraOptions: _propTypes.default.object,
  /** Extra options to pass to Flyout */
  flyoutExtraOptions: _propTypes.default.object,
  /** ColorBar offset */
  colorbarOffset: _propTypes.default.object
});
(0, _defineProperty2.default)(ColorPicker, "defaultProps", {
  disabled: false,
  title: _StringResource.default.get('title'),
  className: '',
  style: {},
  buttonExtraOptions: {},
  flyoutExtraOptions: {},
  colorbarOffset: {
    top: '12px',
    left: '1.25px'
  },
  orientation: _utils.Bidi.isMirroredUI() ? BOTTOM_RIGHT_START : BOTTOM_LEFT_START
});

/***/ }),

/***/ 12331:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
var _ColorPicker = _interopRequireDefault(__webpack_require__(21413));
exports["default"] = _ColorPicker.default;
exports.ColorPicker = _ColorPicker.default;

/***/ }),

/***/ 26935:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _utils = __webpack_require__(78815);
var _ColorPickerResources = _interopRequireDefault(__webpack_require__(89017));
/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// eslint-disable-line
var _default = exports["default"] = new _utils.StringResource(_ColorPickerResources.default);

/***/ }),

/***/ 42196:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-common-colorpicker{position:relative}.ba-common-colorpicker__button.size-default{border:0px;padding:0px;min-height:0px}.ba-common-colorpicker__button svg{margin:0px !important}.ba-common-colorpicker__colorbar{color:#343334;width:14px;height:4px;position:absolute;-ms-high-contrast-adjust:none}.ba-common-colorpicker__colorbar:hover{cursor:pointer}.ba-common-colorpicker__flyout{padding:.3em;width:166px;flex-wrap:wrap;display:flex;justify-content:flex-start;-ms-high-contrast-adjust:none}.ba-common-colorpicker__cell{display:inline-block;width:16px;height:16px;margin:2px 1.6px;border:1px solid}.ba-common-colorpicker__cell:hover{cursor:pointer}.ba-common-colorpicker__cell{border-color:#eaeaea}", ""]);

// exports
exports.locals = {
	"colorpickerClassName": "\"ba-common-colorpicker\""
};

/***/ }),

/***/ 4457:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_ColorPicker_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42196);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_ColorPicker_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_ColorPicker_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_ColorPicker_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_ColorPicker_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_ColorPicker_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_ColorPicker_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_ColorPicker_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_ColorPicker_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 93379:
/***/ ((module) => {

"use strict";


var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 90569:
/***/ ((module) => {

"use strict";


var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ }),

/***/ 19216:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ }),

/***/ 3565:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 7795:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ }),

/***/ 44589:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ }),

/***/ 71933:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/text--color_32");

/***/ }),

/***/ 68779:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 38213:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 97880:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 98060:
/***/ ((module) => {

"use strict";
module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 580:
/***/ ((module) => {

"use strict";
module.exports = require("prop-types");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 32477:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__32477__;

/***/ }),

/***/ 7662:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__7662__;

/***/ }),

/***/ 78815:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__78815__;

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(12331));
/******/ return __webpack_exports__;
/******/ }
]);
});